"use strict";
//
// @Javi: This is some code I found at:
// https://home.ubalt.edu/ntsbarsh/business-stat/otherapplets/pvalues.htm
// I used it to calculate the p-values of a distribution
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudT = void 0;
const Pi = Math.PI;
const PiD2 = Pi / 2;
/**
 * Calculates the p-value of a T-Student distribution
 * @param t Value
 * @param n Degree freedom
 * @return number p-value
 */
function StudT(t, n) {
    t = Math.abs(t);
    const w = t / Math.sqrt(n);
    const th = Math.atan(w);
    if (n === 1) {
        return 1 - th / PiD2;
    }
    const sth = Math.sin(th);
    const cth = Math.cos(th);
    if ((n % 2) === 1) {
        return 1 - (th + sth * cth * StatCom(cth * cth, 2, n - 3, -1)) / PiD2;
    }
    else {
        return 1 - sth * StatCom(cth * cth, 1, n - 3, -1);
    }
}
exports.StudT = StudT;
function StatCom(q, i, j, b) {
    let zz = 1;
    let z = zz;
    let k = i;
    while (k <= j) {
        zz = zz * q * k / (k - b);
        z = z + zz;
        k = k + 2;
    }
    return z;
}
//
// @Javi: I am not using the rest new but it may be useful
//
/*

function Norm(z) {
    z = Math.abs(z);
    let p = 1 + z * (0.04986735 + z * (0.02114101 + z * (0.00327763 + z * (0.0000380036 + z * (0.0000488906 + z * 0.000005383)))));
    p = p * p; p = p * p; p = p * p;
    return 1 / (p * p);
}

function ChiSq(x, n) {
    if (n == 1 & x > 1000) { return 0; }
    if (x > 1000 | n > 1000) {
        const q = ChiSq((x - n) * (x - n) / (2 * n), 1) / 2;
        if (x > n) { return q; } { return 1 - q; }
    }
    let p = Math.exp(-0.5 * x); if ((n % 2) == 1) { p = p * Math.sqrt(2 * x / Pi); }
    let k = n; while (k >= 2) { p = p * x / k; k = k - 2; }
    let t = p; let a = n; while (t > 0.0000000001 * p) { a = a + 2; t = t * x / a; p = p + t; }
    return 1 - p;
}

function FishF(f, n1, n2) {
    const x = n2 / (n1 * f + n2);
    if ((n1 % 2) == 0) { return StatCom(1 - x, n2, n1 + n2 - 4, n2 - 2) * Math.pow(x, n2 / 2); }
    if ((n2 % 2) == 0) { return 1 - StatCom(x, n1, n1 + n2 - 4, n1 - 2) * Math.pow(1 - x, n1 / 2); }
    const th = Math.atan(Math.sqrt(n1 * f / n2)); let a = th / PiD2; const sth = Math.sin(th); const cth = Math.cos(th);
    if (n2 > 1) { a = a + sth * cth * StatCom(cth * cth, 2, n2 - 3, -1) / PiD2; }
    if (n1 == 1) { return 1 - a; }
    let c = 4 * StatCom(sth * sth, n2 + 1, n1 + n2 - 4, n2 - 2) * sth * Math.pow(cth, n2) / Pi;
    if (n2 == 1) { return 1 - a + c / 2; }
    let k = 2; while (k <= (n2 - 1) / 2) { c = c * k / (k - 0.5); k = k + 1; }
    return 1 - a + c;
}


function ANorm(p) {
    let v = 0.5; let dv = 0.5; let z = 0;
    while (dv > 1e-6) { z = 1 / v - 1; dv = dv / 2; if (Norm(z) > p) { v = v - dv; } else { v = v + dv; } }
    return z;
}

function AChiSq(p, n) {
    let v = 0.5; let dv = 0.5; let x = 0;
    while (dv > 1e-10) { x = 1 / v - 1; dv = dv / 2; if (ChiSq(x, n) > p) { v = v - dv; } else { v = v + dv; } }
    return x;
}

function AStudT(p, n) {
    let v = 0.5; let dv = 0.5; let t = 0;
    while (dv > 1e-6) { t = 1 / v - 1; dv = dv / 2; if (StudT(t, n) > p) { v = v - dv; } else { v = v + dv; } }
    return t;
}

function AFishF(p, n1, n2) {
    let v = 0.5; let dv = 0.5; let f = 0;
    while (dv > 1e-10) { f = 1 / v - 1; dv = dv / 2; if (FishF(f, n1, n2) > p) { v = v - dv; } else { v = v + dv; } }
    return f;
}

function CalcN(form) {
    const pn1 = Fmt(Norm(eval(form.z.value)));
    if (pn1.indexOf('e') != -1) {
        form.pn.value = 'Almost Zero';
    } else {
        form.pn.value = pn1;
    }
}

function CalcNr(form) { form.z.value = Fmt(ANorm(eval(form.pn.value))); }

function CalcT(form) {
    const pt1 = Fmt(StudT(eval(form.t.value), eval(form.nt.value)));
    if (pt1.indexOf('e') != -1) {
        form.pt.value = 'Almost Zero';
    } else {
        form.pt.value = pt1;
    }
}
function CalcTr(form) { form.t.value = Fmt(AStudT(eval(form.pt.value), eval(form.nt.value))); }

function CalcX(form) {
    const px1 = Fmt(ChiSq(eval(form.x.value), eval(form.nx.value)));
    if (px1.indexOf('e') != -1) {
        form.px.value = 'Almost Zero';
    } else {
        form.px.value = px1;
    }
}

function CalcXr(form) { form.x.value = Fmt(AChiSq(eval(form.px.value), eval(form.nx.value))); }

function CalcF(form) {
    const pf1 = Fmt(FishF(eval(form.f.value), eval(form.n1.value), eval(form.n2.value)));
    if (pf1.indexOf('e') != -1) {
        form.pf.value = 'Almost Zero';
    } else {
        form.pf.value = pf1;
    }
}
function CalcFr(form) {
    form.f.value = Fmt(AFishF(eval(form.pf.value), eval(form.n1.value), eval(form.n2.value)));
}

function Fmt(x) {
    let v;
    if (x >= 0) { v = '' + (x + 0.0005); } else { v = '' + (x - 0.0005); }
    return v.substring(0, v.indexOf('.') + 4);
}

*/
